import React, { FC } from 'react'
import _ from 'lodash'
import { SingleRow_s } from 'components/table/hovers/hover-styles'

import { localizeNum, isValidNumber } from "data/lib/numbers"
import { formatDate, isValidDate } from 'data/lib/dates'

import { Label_s } from 'styles/app-styles'

type BasicHoverProps = {
  config: {},
  data: [],
  areaMeasureData: object[],
  downtimeData: object[],
  freeRentData: object[],
  increaseData: object[],
  inflationData: object[],
  lineItemData: object[],
  state: string,
  valuationData: object[],
  payoutData: object[],
  rentData: object[],
  tenantCapitalData: object[]
}

const BasicHover: FC<BasicHoverProps> = (props) => {
  return (
    <SingleRow_s>
      { props.config[props.state].map((c, i) => {
        const label:string|null = c.label || null
        let   val:any|null      = null
        if (Array.isArray(c.key)){
          for (let i of c.key){
            val = val ? val[i] : props.data[i]
          }
        } else val = props.data[c.key]
        // If named item, show code
        const codeFor = (val) => _.get(val, 'code')
        if (c.key && val && c.key[c.key.length - 1] === 'increaseNamedItemId'){
          val = codeFor(_.find(props.increaseData, { increaseid: val }))
        }
        if (c.key && val && c.key[c.key.length - 1] === 'inflationNamedItemId'){
          val = codeFor(_.find(props.inflationData, { inflationid: val }))
        }
        if (c.key && val && c.key[c.key.length - 1] === 'payoutNamedItemId'){
          val = codeFor(_.find(props.payoutData, { payoutid: val }))
        }
        if (c.key && val && (c.key[c.key.length - 1] === 'areaid' || c.key[c.key.length - 1] === 'areaMeasureNamedItemId')){
          val = codeFor(_.find(props.areaMeasureData, { areaid: val }))
        }
        if (c.key && val && c.key[c.key.length - 1] === 'downtimeNamedItemId'){
          val = codeFor(_.find(props.downtimeData, { downtimeid: val }))
        }
        if (c.key && val && c.key[c.key.length - 1] === 'freeRentNamedItemId'){
          val = codeFor(_.find(props.freeRentData, { freerentid: val }))
        }
        if (c.key && val && c.key[c.key.length - 1] === 'rentNamedItemId'){
          val = codeFor(_.find(props.rentData, { rentid: val }))
        }
        if (c.key && val && c.key[c.key.length - 1] === 'lineItemId'){
          val = codeFor(_.find(props.lineItemData, { lineitemid: val }))
        }
        if (c.key && val && c.key[c.key.length - 1] === 'tenantCapitalNamedItemId'){
          val = codeFor(_.find(props.tenantCapitalData, { tenantcapitalid: val }))
        }
        if (c.key && val && c.key[c.key.length - 1] === 'valuationScenario'){
          const vs = _.find(props.valuationData, { valuationPeriod: val })
          val = `#${val}: ${_.get(vs, "valuationDescription")}`
        }

        // If boolean, show 'yes' for checked
        if (val && typeof val === 'boolean'){
          val === true ? val = 'Yes' : val = 'No'
        }
        // If date, show MM/YYYY date
        if (isValidDate(val)){
          val = formatDate(val, 'MM/YYYY');
        }
        // If number, show 4 digits of precision
        if (isValidNumber(val)){
          val =`${localizeNum(val, 4)}`
        }

        return (
          <div>
            { label && <Label_s>{ label }</Label_s> }
            { val && <span>{ val }
            </span> }
          </div>
        )
      })}
    </SingleRow_s>
  )
}

export default BasicHover